import { ApButtonSecondary, ApSelect, colors } from '@alixpartners/ui-components';
import styled, { css } from 'styled-components';
import { grey500, black } from 'styles/colors';

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
`;

export const GeographyWrapper = styled.div`
	margin-left: 264px;
`;

export const MetadataSummaryLine = styled.tr``;

export const SummaryLabel = styled.td`
	color: ${grey500};
	font-size: 16px;
	line-height: 32px;
	text-transform: uppercase;
	font-weight: normal;
	padding: 12px 64px 12px 12px;
`;

export const SummaryValue = styled.td`
	color: ${black};
	font-size: 16px;
	font-weight: 500;
	line-height: 32px;
	display: flex;
	align-items: flex-start;
	padding: 8px 0;
	height: 56px;
	width: 640px;
	min-width: 360px;
`;

export const SummaryLabelGeography = styled(SummaryLabel)`
	vertical-align: top;
`;

export const SummaryValueGeography = styled(SummaryValue)`
	height: auto;
`;

export const EditGeographyButton = styled(ApButtonSecondary)`
	margin-left: 12px;
	width: 80px;
	min-width: 80px !important;
`;

export const ValueWrapper = styled.div`
	display: inline-flex;
	box-sizing: content-box;
	width: 177px;
	margin-bottom: 19px;
	padding-right: 32px;
`;

export const SelectWrapper = styled.div`
	label {
		display: none;
	}

	& span {
		line-height: 24px;
		border-color: ${colors.grey4};
	}
`;

export const Select = styled(ApSelect)`
	width: 384px;
	min-width: 384px !important;
	${({ small }) =>
		small && css`
			max-width: 175px !important;
			min-width: 175px !important;
		`
	}
`;
